function getFees(data) {
   var fee = 0;
   var found = false;
   var foundFee = {}
   if(!data.unit.fieldOfEducation){
      data.unit = data.unit.unit
   }

   if(data.log) console.log("Getting fees for -> " + data.unit.code)

   if(data.fees.fees[2].units.length > 0 && !found){
      foundFee = data.fees.fees[2].units.filter(x =>  x.unitCode === data.unit.code)
      if(foundFee.length > 0){
         fee = foundFee[0]
         found = true
         if(data.log) console.log("Unit Based Fees NOT Fee per EFTSL")
      }
   }
   if(data.fees.fees[3].schoolOverrides.length > 0 && data.courseAbbreviation && !found){
      foundFee = data.fees.fees[3].schoolOverrides.filter(x => {
         return data.courseAbbreviation.toLowerCase().includes(x.courseCode.toLowerCase()) && data.unit.code.startsWith(x.unitCode.replace(/\*/g, ''))
      })
      if(foundFee.length > 0){
         fee = foundFee[0]
         found = true
         if(data.log) console.log("School Based Fees", {course: data.courseCode, courseAbbrev: data.courseAbbreviation, fee: fee.fee, credits: data.unit.credits, unit: data.unit.code, feeScaled: Math.floor((foundFee[0].fee/24)*data.unit.credits)})
      }
   }

   if(data.fees.fees[1].courses.length > 0 && data.courseCode && !found){
      foundFee = data.fees.fees[1].courses.filter(x =>  x.courseCode === data.courseCode)
      if(foundFee.filter(x => x.unitCode === data.unit.code).length > 0){
         foundFee = foundFee.filter(x => x.unitCode === data.unit.code)
         fee = foundFee[0]
         found = true
         if(data.log) console.log("Course Unit Based Fees")
      }else if(foundFee.filter(x => x.unitCode === "N/A").length > 0){
         foundFee = foundFee.filter(x => x.unitCode === "N/A")
         fee = foundFee[0]
         found = true
         if(data.log) console.log("Course Based Fees", {course: data.courseCode, fee: fee.fee, credits: data.unit.credits, unit: data.unit.code, feeScaled: Math.floor((foundFee[0].fee/24)*data.unit.credits)})
      }
   }
   if(data.fees.fees[0].fieldsOfEducation && !found){
      var foe = data.unit.fieldOfEducation.detailed.substring(0,6)
      foundFee = data.fees.fees[0].fieldsOfEducation.filter(x => foe === x.fieldOfEducation)
      fee = foundFee[0]
      if(data.log) console.log("FOE Based Fees", {foe, fee: fee.fee, credits: data.unit.credits, unit: data.unit.code, feeScaled: Math.floor((foundFee[0].fee/24)*data.unit.credits)} )
   }
   if(foundFee[0]){
      fee = Math.floor((foundFee[0].fee/24)*data.unit.credits)
   }else{
      fee = "  -  "
   }
   if(data.log) console.log("=================================================")
   return fee
}

export {getFees}
